import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import Title from "../component/Title";

const Edit = ({ ...props }) => (
  <RaEdit
    {...props}
    undoable={false}
    title={
      <Title resource="executive-project-wp-activities" source="full_index" />
    }
  >
    <Form />
  </RaEdit>
);
export default Edit;
